package nl.astraeus.wiki.view

import kotlinx.html.div
import nl.astraeus.css.properties.Display
import nl.astraeus.css.properties.rem
import nl.astraeus.komp.HtmlBuilder
import nl.astraeus.wiki.css.Css.defineCss
import nl.astraeus.wiki.css.CssId
import nl.astraeus.wiki.css.CssName

class ConfirmModal(
  title: String,
  val message: String,
  val cancelCallback: () -> Unit = {},
  val confirmCallback: () -> Unit
) : Modal(title) {

  override val confirmListener: () -> Unit
    get() = {
      confirmCallback.invoke()
      close()
    }

  override val closeListener: () -> Unit
    get() = cancelCallback

  override val size: ModalSize
    get() = ModalSize.EXTRA_SMALL

  override fun HtmlBuilder.renderContent() {
    div(ConfirmModalCss.name) {
      +message
    }
  }

  companion object : CssId("login-register") {
    object ConfirmModalCss : CssName

    init {
      defineCss {
        select(ConfirmModalCss.cls()) {
          margin(0.4.rem, 0.rem)
          display(Display.flex)
        }
      }
    }
  }

}
